export default {
  filters: 'Filters',
  filtersPlaceholder: 'Combine up to five programming languages, softwares...',
  typeOfProjects: 'Type of projects',
  noResult: 'No project found...'
}
